import '../css/app.scss';

// import bootstrap from 'bootstrap';
// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import $ from "jquery";
import '../../node_modules/selectric';
import BigPicture from 'bigpicture';

import Instafeed from 'instafeed.js';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

//import 'bootstrap/js/dist/collapse';

$(function () {
	$('.preloader').fadeOut(1000);

	let windowlargeur = window.innerWidth;


	$('select').selectric();


	// video lightview bigpicture
	if (document.querySelector('.video-lightview') !== null) {
		$(document).on("click", ".video-lightview", function (e) {
			e.preventDefault();


			var className = e.target.className;
			var videoId = e.target.getAttribute('href');


			if (~className.indexOf('htmlvid')) {
				BigPicture({
					el: e.target,
					vidSrc: e.target.getAttribute('href'),
				})
			} else if (~className.indexOf('video-vimeo')) {

				var regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
				var parseUrl = regExp.exec(videoId);
				videoId = parseUrl[5];
				BigPicture({
					el: e.target,
					vimeoSrc: videoId,
				})
			} else if (~className.indexOf('video-youtube')) {

				videoId = videoId.split('v=')[1];
				var ampersandPosition = videoId.indexOf('&');
				if (ampersandPosition !== -1) {
					videoId = videoId.substring(0, ampersandPosition);
				}

				BigPicture({
					el: e.target,
					ytSrc: videoId,
				})
			}
		});
	};


	// apply min-height to element
	function minHeightWindow() {
		let windowHeight = window.innerHeight;
		let hero = document.querySelector(".hero-header");
		if (hero != null) {
			hero.setAttribute("style", "height:" + windowHeight + 'px');
		}
	}

	minHeightWindow();
	// window.onresize = minHeightWindow;


	//menu sur la droite page historique 
	function menuHistory() {
		if (document.querySelector(".itemWithMenu")) {
			// console.log(document.querySelector('.sticky-sub-header').offsetHeight);
			// console.log( document.querySelector('.header').offsetHeight);

			let offsetHeader = document.querySelector('.sticky-sub-header').offsetHeight + 53;
			let menuSideHeight = $(window).height() - offsetHeader;
			let menuSideMarge = 100;
			$('.menu-side').css('height', menuSideHeight);
			$('.menu-side ul').css('height', menuSideHeight - menuSideMarge);

			//creation auto of the side menu

			$('.itemWithMenu').each(function () {
				let itemDate = $(this).find('.item-date').html();
				let itemNameTitle = $(this).find('.heading').text();
				let slugItemName = $(this).find('.item-date').text() + '-' + itemNameTitle;
				let itemNameUrl = slug(slugItemName);

				// add on item-bassin the id 
				$(this).attr('id', itemNameUrl);

				$('.menu-side ul').append($('<li><span class="line"></span><div class="puceItem" id="puceItem-' + itemNameUrl + '"><a class="js-scroll square" href="#' + itemNameUrl + '" title="' + slugItemName + '"></a><span class="puceName">' + itemDate + '</span></div></li> '));

			});


			let numberLi = $('.menu-side ul li').length;
			numberLi = numberLi - 1; // on en enlève un car il y a moins de trait
			let losange = $('.menu-side ul li .square').outerHeight(true);
			$('.menu-side ul li:not(:last-of-type)').css('height', (menuSideHeight - menuSideMarge - (losange * 2)) / numberLi);

			// on hover tooltip

			$('.menu-side ul li').each(function (i) {

				$('.menu-side ul li .square').eq(i).bind('mouseover', function () {
					$('.menu-side ul li .puceName').eq(i).stop().animate({
						opacity: 1,
						right: 0,
					});
				})
				$('.menu-side ul li .square').eq(i).bind('mouseout', function () {
					$('.menu-side ul li .puceName').eq(i).stop().animate({
						opacity: 0,
						right: "-10px",
					});
				})
			});


			$(window).scroll(function () {

				$('.itemWithMenu').each(function () {
					let itemTop = $(this).offset().top;

					if (itemTop <= $(window).scrollTop() + ($(window).height() / 2)) {
						$('#puceItem-' + $(this).attr('id')).addClass('active');

					} else {
						$('#puceItem-' + $(this).attr('id')).removeClass('active');
					}
				});
			});
		}
	}


	menuHistory();




	//---------------------------//
	// STICKY HEADER SUB MENU
	//---------------------------//

	if (document.querySelector('.sticky-sub-header') !== null) {
		var sticky = $('.header .wrapper-menu');
		var stickyHeaderHeight = sticky.outerHeight();

		var adminBar = 0;
		if (document.querySelector('#wpadminbar') !== null) {
			adminBar = $('#wpadminbar').outerHeight();
		};
		// $('body').css('marginTop', stickyHeaderHeight + 'px');


		var EltoStick = $('.sticky-sub-header');
		EltoStick.find('.container-fluid').wrapAll("<div class='sticky-content' />");
		var EltoStickHeight = EltoStick.find('.sticky-content').outerHeight();
		EltoStick.css('height', EltoStickHeight + 'px');

		$(window).on('resize', function () {
			EltoStickHeight = EltoStick.find('.sticky-content').outerHeight();
			EltoStick.css('height', EltoStickHeight + 'px');
		});
		$(window).scroll(function () {

			stickyHeaderHeight = sticky.outerHeight();

			detectSticky();
		});

		detectSticky();


	}

	function detectSticky() {
		var scroll = $(window).scrollTop()
		var stickyPosition = EltoStick.offset().top - stickyHeaderHeight;


		if (scroll > (stickyPosition - adminBar)) {
			EltoStick.addClass('active');
			EltoStick.find('.sticky-content').css('top', stickyHeaderHeight + adminBar + 'px');
		} else if (scroll <= (stickyPosition + adminBar)) {
			EltoStick.removeClass('active');
		}
	}



	//sticky header 
	const headerToStick = $('.header');
	let headerToStickHeight = headerToStick.outerHeight();
	const stickyHeader = function () {
		var scroll = $(window).scrollTop();
		const topMenuEl = $('.wrapper-topMenu');
		let topMenuHeight = topMenuEl.outerHeight(true);
		if (scroll >= 1) {
			headerToStick.addClass('sticky');
			headerToStick.css('transform', 'translateY(-' + topMenuHeight + 'px)');
		} else {
			headerToStick.removeClass('sticky');
			headerToStick.css('transform', 'translateY(0)');

		}
	}

	$(window).scroll(function () {
		stickyHeader();
	});

	stickyHeader();


	if (document.querySelector(".hero-header")) {
		$('.hero-header').css('padding-top', headerToStickHeight + 'px');
	}

	if (document.querySelector(".page-header-marge")) {
		$('.page-header-marge').css('padding-top', headerToStickHeight + 76 + 'px');
	}




	$(document).on("click", ".share_button", function (e) {
		e.preventDefault();
		var shareContent = $(this).parent().parent().find('.share_content');
		shareContent.slideToggle();
	});

	$(document).on("click", ".close_share", function () {
		var shareContent = $(this).parent();
		shareContent.slideUp();
	});



	$(document).on("click", ".search-mobile, .close", function (e) {
		e.preventDefault();
		$('.header_right_sidebar').toggleClass('active');
	});






	//  click on anchor #
	// function smoothScrollAnchor(target, url) {
	// 	let wrapperTop = $('.wrapper-topMenu').outerHeight();
	// 	headerToStickHeight = headerToStick.outerHeight() - wrapperTop;

	// 	let targetEl = document.getElementById(target);

	// 	if (targetEl != null) { //if element is present in page

	// 		let targetTop = targetEl.getBoundingClientRect().top + window.scrollY;
	// 		let spacing = 50; // only for content


	// 		// si la target est dans historique  ou rhenan
	// 		if (targetEl.classList.contains('itemWithMenu') === true) {
	// 			spacing = 50 + $('.sticky-content').outerHeight();
	// 		}


	// 		//si c'était un click c'est la fleche pour aller vers le debut du contenu
	// 		if (targetEl.getAttribute('id') === 'content-start') {

	// 			spacing = -1;
	// 		 }


	// 		$('html, body').stop().animate({
	// 			'scrollTop': targetTop - (headerToStickHeight + spacing) + 'px' //reduce of the height of your fixed navigation
	// 		}, 900);


	// 		//add url in history
	// 		if (window.history && window.history.pushState) {
	// 			window.history.pushState("", document.title, '#' + target);
	// 		}
	// 	} else {
	// 		window.location.href = url;
	// 	}
	// }





	let spacing = 50; // only for content

	function smoothScrollAnchor(targetname) {

		let el = targetname.replace("#", "");
		if (document.getElementById(el) != null && targetname !== "#tarteaucitron") { //if element is present in page
			var $target = $(targetname);

			// si la target est dans historique  ou rhenan
			if ($target.hasClass('itemWithMenu') === true) {
				spacing = 50 + $('.sticky-content').outerHeight();
			}

			//si c'était un click c'est la fleche pour aller vers le debut du contenu
			if ($target.attr('id') === 'content-start') {
				spacing = 0;
			}

			if (window.matchMedia("(max-width: 991px)").matches) {
				/* the view port is at least 400 pixels wide */
				headerToStickHeight = 58;
			} else {
				headerToStickHeight = 68;
			}

			$('html, body').animate({
				'scrollTop': $target.offset().top - (headerToStickHeight + spacing) + 'px'
			}, 200, "linear");
		}
	}




	$(document).on("click", "a[href*=\\#]", function () {
		var targetname = this.hash;
		smoothScrollAnchor(targetname);
	});


	if (window.location.hash.length !== 0) {
		var targetname = window.location.hash;
		smoothScrollAnchor(targetname);
	}





	//function transform string in slug  ( for scroll to )
	function slug(str) {
		var $slug = '';
		var trimmed = $.trim(str);
		$slug = trimmed.replace(/[^a-z0-9-]/gi, '-').
			replace(/-+/g, '-').
			replace(/^-|-$/g, '');
		return $slug.toLowerCase();
	}

	// animation menu
	// const $menu = $('.main_menu');
	const $header = $('.header');
	// const $adminBar = $('#wpadminbar');

	if (document.querySelector(".hamburger")) {
		$(document).on("click", ".hamburger", function () {
			$(this).toggleClass('is-active');
			$header.toggleClass('menu_open');
		});

		$('.menu-item-has-children').after().click(function () {
			// e.preventDefault();
			$(this).toggleClass('menu-element-open');
			$(this).find('.sub-menu').slideToggle();
		});
	}


	// const menuMobile = function () {
	// 	if ($(window).innerWidth() <= 991) {
	// 		let $headerHeight = $header.outerHeight();

	// 		if ($adminBar.length) {
	// 			let $adminBarHeight = $adminBar.height();
	// 			$menu.css('top', $headerHeight + $adminBarHeight + 'px');

	// 		} else {
	// 			$menu.css('top', $headerHeight);

	// 		}
	// 	} else {
	// 		$menu.removeAttr('style');
	// 	}
	// }

	// menuMobile();
	// window.onresize = menuMobile;




	let speed = 1500;
	$('.fullPage').each(function (index) {
		$(this).addClass('s' + index);
		var element = $(this).find('.gallery-pages');

		var slider = new Swiper(element[0], {
			slidesPerView: '1',
			touchRatio: 0.4,
			freeMode: false,
			loop: false,
			autoHeight: false,
			speed: speed,
			threshold: 10,
			grabCursor: true,
			on: {
				slideChange: function () {
					let el = this;

					let active = el.activeIndex;
					// if( el.activeIndex === 0){
					// 	active = 0;
					// }else{
					// 	active = el.activeIndex - 1;
					// }

					$(el.el).parent().parent().find('.menu-slider').find('li').removeClass('active');
					$(el.el).parent().parent().find('.menu-slider').find('li[data-slide-to=' + active + ']').addClass('active');
				},
			}
		});



		$(this).find('.menu-slider li').on("click", function () {
			var el = $(this).data('slide-to');
			slider.slideTo(el, speed, true); // use slideto if not loop
		});

		if ($(window).innerWidth() <= 990) {
			slider.destroy(true, true);
		}

	});


	if ($(window).innerWidth() <= 990) {
		var previousActiveTabIndex = 1;

		$(".fullPage:not([data-tab-index=1])").fadeOut();

		$('.menu-accordion li a').on("click", function (e) {
			e.preventDefault();
			var tabClicked = $(this).data("tab-index");
			$('.menu-accordion li a').parent().removeClass("active");
			$(this).parent().addClass('active');

			if (tabClicked !== previousActiveTabIndex) {
				$(".fullPage").each(function () {
					if ($(this).data("tab-index") === tabClicked) {
						$(".fullPage").fadeOut();
						$(this).fadeIn();
						previousActiveTabIndex = $(this).data("tab-index");
						return;
					}
				});
			}

		});
	}





	if ($('.navbar-scroll__wrapper').length > 0) {
		$('.navbar-scroll__wrapper').each(function () {
			let el = $(this);
			let navActiveOnglet = $(this).find('.nav-item.active a').attr('slide-index');
			// console.log( navActiveOnglet );


			new Swiper('.' + el[0].className, {
				slidesPerView: 'auto',
				grabCursor: true,
				freeMode: true,
				loop: false,
				initialSlide: navActiveOnglet, // first slide must be 0 
			});

		});
	};


	$('#select-filter').change(function () {
		var $cat = $(this).val();
		window.location.replace(location.protocol + '//' + location.host + location.pathname + '?cat=' + $cat);
	});

	if ($('.swiper-gallery').length > 0) {
		new Swiper('.swiper-gallery', {
			slidesPerView: 1.2,
			nested: true,
			loop: true,
			freeMode: true,
			grabCursor: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			touchRatio: 1,
			breakpoints: {
				// when window width is >= 480px
				480: {
					slidesPerView: 2.2,
				},

				768: {
					slidesPerView: 2.5,

				},
				// when window width is >= 640px
				991: {
					slidesPerView: 2.5,
					spaceBetween: 40
				}
			}

		});
	}



	const gsap = window.gsap;
	const CustomEase = window.CustomEase;
	const ScrollTrigger = window.ScrollTrigger;
	gsap.registerPlugin(ScrollTrigger, CustomEase);


	CustomEase.create("hop", "M0,0 C0.95,0 0.058,1 1,1");

	gsap.utils.toArray(".sectionHalf").forEach((section, i) => {
		section.overlay = section.querySelector('.overlay');
		section.img = section.querySelector('.img');
		section.content = section.querySelectorAll('.animate-content');
		// section.text = section.querySelector('.animate-text');


		function numIsPair(n) {
			return (n & 1) ? false : true;
		}

		let direction;
		if (numIsPair(i)) {
			direction = "100%";
		} else {
			direction = "-100%";
		}


		var tlImage = gsap.timeline({
			scrollTrigger: {
				trigger: section.img,
				start: 'top 70%', // when the top of the trigger hits the center of the viewport
				markers: false
			}
		});

		var tlContent = gsap.timeline({
			scrollTrigger: {
				trigger: section,
				start: 'top center', // when the top of the trigger hits the center of the viewport
				markers: false
			}
		});

		tlContent
			.from(section.content, { duration: 1, y: 30, opacity: 0, stagger: 0.3 });

		tlImage
			.fromTo(section.overlay, { translateX: 0 }, { translateX: direction, ease: "hop", duration: 0.8 })
			.fromTo(section.img, 1.5, { scale: "1.1" }, { scale: "1" }, '-=0.8');
	});


	gsap.utils.toArray(".fullPage").forEach((el) => {
		var tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'top 80%', // when the center of the trigger hits the center of the viewport
				markers: false
			}
		});
		tl.from(el, { duration: 1, y: '70px', opacity: 0 });
	});



	// parallax header
	let bg = document.querySelector(".paralax-img"),
		heroHeader = document.querySelector(".hero-header"),
		heroHeading = document.querySelector(".hero-header h1"),
		heroText = document.querySelector(".hero-header p");

	gsap.to(bg, {
		backgroundPosition: "50% -50%",
		ease: "none",
		scrollTrigger: {
			trigger: heroHeader,
			start: "top bottom",
			end: "bottom top",
			scrub: true
		}
	});


	if (heroHeading !== null && heroText !== null) {
		gsap.fromTo([heroHeading, heroText], 2, { y: '50px', opacity: 0 }, { y: 0, opacity: 1, stagger: 0.6 });
	}

	let proxy = { skew: 0 },
		skewSetter = gsap.quickSetter(".list-actions .wrapper-img", "skewY", "deg"), // fast 
		clamp = gsap.utils.clamp(-10, 10); // don't let the skew go beyond 20 degrees. 

	ScrollTrigger.create({
		scrub: 0.5, //smooth 
		onUpdate: (self) => {
			let skew = clamp(self.getVelocity() / -1000);
			// only do something if the skew is MORE severe. Remember, we're always tweening back to 0, so if the user slows their scrolling quickly, it's more natural to just let the tween handle that smoothly rather than jumping to the smaller skew.
			if (Math.abs(skew) > Math.abs(proxy.skew)) {
				proxy.skew = skew;
				gsap.to(proxy, { skew: 0, duration: 0.8, ease: "power3", overwrite: true, onUpdate: () => skewSetter(proxy.skew) });
			}
		}
	});

	// make the right edge "stick" to the scroll bar. force3D: true improves performance
	gsap.set(".list-actions .wrapper-img", { transformOrigin: "right center", force3D: true });




	const delSections = document.querySelectorAll(".item-bassin");
	if (windowlargeur >= 768) {

		delSections.forEach(section => {
			const containerAnim = gsap.to(section.querySelector(".wrapper"), {
				y: "0px",
				ease: "none"
			});


			section.image = section.querySelector(".floating-effect");

			const imageAnim = gsap.to(section.image, {
				y: '-10%',
				ease: "ease",
				paused: true
			});

			const scrub = gsap.to(imageAnim, {
				progress: 1,
				paused: true,
				ease: "power3",
				duration: parseFloat(section.image.dataset.scrub) || 0.1, // recupere le data-scrub dans le code
				overwrite: true
			});


			section.content = section.querySelector(".wrapper-content");
			const textAnim = gsap.to(section.content, {
				y: "30px",
				ease: "ease",
				paused: true
			});

			const scrubText = gsap.to(textAnim, {
				progress: 1,
				paused: true,
				ease: "power3",
				duration: parseFloat(section.content.dataset.scrub) || 0.1, // recupere le data-scrub dans le code
				overwrite: true
			});

			ScrollTrigger.create({
				animation: containerAnim,
				scrub: 0.5, //smooth 
				trigger: section,
				start: "top bottom",
				end: "bottom top",
				onUpdate: self => {
					scrub.vars.progress = self.progress;
					scrub.invalidate().restart();

					scrubText.vars.progress = self.progress;
					scrubText.invalidate().restart();
				}
			});
		});
	} else {
		delSections.forEach(section => {
			var tl = gsap.timeline({
				scrollTrigger: {
					trigger: section,
					start: 'top 80%', // when the center of the trigger hits the center of the viewport
					markers: false
				}
			});
			tl.from(section, { duration: 1, y: '70px', opacity: 0 });
		});
	}






	gsap.defaults({ ease: "power3" });
	gsap.set(".box-reveal", { opacity: 0, y: '30px' });

	ScrollTrigger.batch(".box-reveal", {
		interval: 0.1, // time window (in seconds) for batching to occur. 
		batchMax: 3,   // maximum batch size (targets)
		onEnter: batch => gsap.to(batch, 2, { opacity: 1, y: 0, stagger: 0.2, overwrite: true }),
		start: "20px bottom",
	});





	// ANIMATION PAGE HISTORY
	const history = document.querySelectorAll(".item-history");


	history.forEach(section => {
		section.image = section.querySelector(".wrapper-img");
		section.content = section.querySelector(".wrapper-content");
		section.date = section.querySelector(".item-date");

		// gsap.set(section , { opacity: 0 });
		gsap.set(section.image, { scale: 0.4 });
		gsap.set(section.content, { opacity: 0 });
		gsap.set(section.date, { opacity: 0 });


		ScrollTrigger.create({
			trigger: section,
			pin: false,   // pin the trigger element while active
			// start: start, // when the top of the trigger hits the top of the viewport
			// end: "bottom+=50% 50%",
			start: "top 50%",
			end: "bottom 50%",
			scrub: true, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
			markers: false,
			onEnter: function () { animateEnter(section) },
			// onLeave: function () { animateLeave(section) },
			// onEnterBack: () => animateEnter(section),
			// onLeaveBack: () => animateLeave(section),
		});



		function animateEnter(section) {
			if (!$(section).hasClass('animated')) {
				$(section).addClass('animated');
				// gsap.to(section.parentElement, 1, { zIndex: 999999 });
				gsap.fromTo(section.image, 1, { scale: 0.4, transformOrigin: "center center" }, { scale: 1 });
				gsap.fromTo(section.date, 1, { x: "30px", opacity: 0, transformOrigin: "left top" }, { x: 0, autoAlpha: 1 });
				gsap.fromTo(section.content, 1, { x: "-30px", opacity: 0, transformOrigin: "right top" }, { x: 0, autoAlpha: 1 }, "-=0.1");
			}

		}


		// function animateLeave(section) {
		// 	gsap.to(section.image, { scale: 0.4 })
		// 	gsap.to([section.content, section.date], { opacity: 0 })
		// }

	});



	// Instafeed
	if ($('#instafeed').length > 0) {

		var feed = new Instafeed({
			accessToken: 'IGQWRNWEJ6SldSZAm5kODNveWFQVEZAiV3VSZA28xakMxSzhGbGtWNzdEdGF3aUYtLUllaFhtc3lfODZAKYnU4ZAE5LNkE4dDdoaVQ5TlE5WDVkdnVia0N1RFp1ZAkt2WGl4OE5WbmxERGo4N3lNUQZDZD',
			limit: 12,
			template: '<div class="swiper-slide"><a href="{{link}}" target="_blank"><img src="{{image}}" ></a></div>',
			after: function () {
				new Swiper(".myInstaSwiper", {
					slidesPerView: 2,
					spaceBetween: 20,
					autoplay: true,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
					breakpoints: {
						// when window width is >= 768
						768: {
							slidesPerView: 3,
							spaceBetween: 20
						},
						// when window width is >= 992px
						992: {
							slidesPerView: 4,
							spaceBetween: 20
						},
						// when window width is >= 1024px
						1024: {
							slidesPerView: 5,
							spaceBetween: 20
						}
					}
				});
			}
		});
		feed.run();
	}

});
